<div class="td-wb-toast-message__content"
  role="alert">
  @if (toast().id) {
    <td-wb-analytics-context [analyticsContext]="toast().id" />
  }
  <div class="td-wb-toast-message__status">
    <td-wb-icon class="td-wb-toast-message__icon"
      iconId="approved"
      size="24" />
  </div>
  <div class="td-wb-toast-message__info">
    <div class="td-wb-toast-message__text">
      <span class="td-wb-toast-message__text-success"
        [innerText]="toast().message">
      </span>
    </div>
  </div>
</div>
